/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      //{title: "Analytics Dashboard",        url: "/dashboard/analytics",                icon: "HomeIcon",           is_bookmarked: false},
      //{title: "eCommerce Dashboard",        url: "/dashboard/ecommerce",                icon: "HomeIcon",           is_bookmarked: false},
    ]
  },
  files: {
    key:"file_name",
    data: [
      //{ file_name: "Joe's CV",         from:"Stacy Watson",    file_ext:"doc", size:"1.7 mb"  },
    ]
  },
  contacts: {
    key:"name",
    data: [
      //{ img: require("@/assets/images/portrait/small/avatar-s-4.jpg"),  name: "Rena Brant",          email: "nephrod@preany.co.uk",     time: "21/05/2019" },
    ]
  },
}
/* eslint-enable */
